module.exports = __webpack_public_path__ + "static/media/pier.d5feb0d9.png";